import { Component, OnInit } from '@angular/core';
declare var jquery: any;
declare var $: any;
import 'datatables.net';
import { GridOptions } from "ag-grid/main";
import { Router } from '@angular/router';
import { Globals } from '../../globals';
import { DownloadAssessmentManager } from '../../services/angular/DownloadAssessmentManager';
import { ToastrService } from 'ngx-toastr';
import { CoachService } from 'app/services/coach/CoachService';
import { CryptoJs } from '../../shared/crypto-js/crypto-js.component';
import { FormControl, Validators } from '@angular/forms';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';

@Component({
    selector: 'app-completed-assessments',
    templateUrl: './completed-assessments.component.html',
    styleUrls: ['./completed-assessments.component.scss'],
    providers: [DownloadAssessmentManager]
})
export class CoachCompletedAssessmentsComponent implements OnInit {

    //data: string[] = [];
    regularAsessmentsData: string[] = [];
    asessments360Data: string[] = [];
    dataHeaders: any[];
    gridOptions: GridOptions;
    //gridApi;
    gridColumnApi;
    overlayNoRowsTemplate;
    rowSelection;

    height: number;
    count: number;

    loading: boolean = true;

    //enableResults: boolean = false;
    canAddRaters: boolean = false;
    archiving: boolean = false;
    regularGridApi: any;
    gridApi360: any;
    assessmentType: number = 2.1;
    tags = [];
    tags360 = [];
    addTags = [];
    assessmentEliTags = [];
    assessment360Tags = [];
    assessmentAddTags = [];
    placeholder: string = "Enter tag";

    //filters: string[] = ['ClientFullName', 'AssessmentName', 'CompletedOn'];

    coachTags: any[] = [];
    coachTagsHeaders: any[];
    coachTagsGridApi;
    selectedCoachTags: any[] = [];
    currentAssessmentType: number;
    enabling: boolean = false;
    selectedRowsCount = 0;
    selectedRow: any;

    downloading = false;
    documentNameControl = new FormControl('', [Validators.required]);
    rowCountData: any;

    constructor(
        private _CoachService: CoachService,
        private router: Router,
        public _Globals: Globals,
        private _DownloadAssessmentManager: DownloadAssessmentManager,
        private _toastr: ToastrService,
        private _CryptoJs: CryptoJs
    ) {
        this.overlayNoRowsTemplate = "<span>No row to show</span>";
        this.rowSelection = "multiple";
    }

    ngOnInit() {
        //$('#cHideFilter').addClass('notShow');

        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.dataHeaders = this.createHeaders();

        //method  call
        //this.getCoachCompletedAssessments();

        if (this._Globals.completedUserId == undefined) {
            this.getCoachCompletedAssessmentsByType(1);
            this.getCoachCompletedAssessmentsByType(2);
        } else {
            this.loading = false;
        }
        
    }

    mouseEnter() {
        $('h1').css("padding-bottom", "0px");
    }

    onFocusInput() {
        console.log('onFocusInput');
        setTimeout(() => {
            $('.ng2-tag-input--focused').css('border-bottom', '2px solid skyblue');
        }, 100);
    }

    //deselectFilter(filterName) {
    //    var filterComponent = this.gridApi.getFilterInstance(filterName);
    //    filterComponent.setModel(null);
    //    this.gridApi.onFilterChanged();
    //}

    //showFilter() {
    //    $('#completedAssessments .ag-body-viewport-wrapper').css({ "margin-top": "0" });
    //    $('#cHideFilter').removeClass('notShow');
    //    $('#cHideFilter').addClass('show');

    //    $('#ccShowFilter').addClass('notShow');
    //    $('#ccShowFilter').removeClass('show');
        
    //    if (this.data.length === 0) {
    //        $('#completedAssessments .ag-body-viewport.ag-layout-normal').css('background', 'transparent');
    //    }
    //}

    //hideFilter() {
    //    $('#completedAssessments .ag-body-viewport-wrapper').css({ "margin-top": "-32px", "position": "absolute", "width": "100%", "height": "111%" });
    //    $('#ccShowFilter').removeClass('notShow');
    //    $('#cHideFilter').removeClass('show');

    //    $('#cHideFilter').addClass('notShow');
    //    $('#ccShowFilter').addClass('show');

    //    if (this.data.length === 0) {
    //        $('#completedAssessments .ag-body-viewport.ag-layout-normal').css('background', 'white');
    //    }

    //    console.log('hide filter');
    //    this.filters.forEach((item) => {
    //        this.deselectFilter(item);
    //    });
    //}

    //getCoachCompletedAssessments() {
    //    this._GetCoachCompletedAssessments.getCoachCompletedAssessments().subscribe((data:any) => {
    //        if (this._Globals.validationToken(data.result.Result)) {
    //            let _data = JSON.parse(data.result.Data);
    //            console.log('_data', _data);
    //            this.data = _data;
    //            this.loading = false; 

    //            //if (this.data.length === 0) {
    //            //    $('#completedAssessments .ag-body-viewport.ag-layout-normal').css('background', 'white');
    //            //}
    //        } 
    //    });
    //}

    getCoachCompletedAssessmentsByType(assessmentType: number) {
        this._CoachService.getCoachCompletedAssessmentsByType(assessmentType).subscribe((data: any) => {
            console.log('response_GetCoachCompletedAssessmentsByType', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                if (assessmentType === 1) {
                    this._Globals.completedRegularData = _data;
                } else {
                    this._Globals.completed360Data = _data;
                }
                this.loading = false;
                this._Globals.completedCanEnableResults = false;
                this._Globals.completedCanArchiveAssessments = false;
                this._Globals.completedCanAddTags = false;
            } 

        });
    }

    getCoachCompletedAssessmentsByTypeByTag(assessmentType: number, tags:string[]) {
        this._CoachService.getCoachCompletedAssessmentsByTypeByTag(assessmentType, tags).subscribe((data: any) => {
            console.log('response_GetCoachCompletedAssessmentsByTypeByTag', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);
                if (_data.length > 0) {
                    if (assessmentType === 1) {
                        this._Globals.completedRegularData = _data;
                    } else {
                        this._Globals.completed360Data = _data;
                    }
                } else {
                    if (tags.length === 0) {
                        this.getCoachCompletedAssessmentsByType(assessmentType);
                    } else {
                        if (assessmentType === 1) {
                            this._Globals.completedRegularData = [];
                        } else {
                            this._Globals.completed360Data = [];
                        }
                    }
                }
                this._Globals.completedCanEnableResults = false;
                this._Globals.completedCanArchiveAssessments = false;
                this._Globals.completedCanAddTags = false;
            } 

        });
    }

    onItemAdded(assessmentType, e) {
        console.log("onItemAdded", e);

        if (assessmentType === 1) {
            this.assessmentEliTags.push(e.value);
            console.log(this.assessmentEliTags);
            this.getCoachCompletedAssessmentsByTypeByTag(1, this.assessmentEliTags);
        } else if (assessmentType === 2) {
            this.assessment360Tags.push(e.value);
            console.log(this.assessment360Tags);
            this.getCoachCompletedAssessmentsByTypeByTag(2, this.assessment360Tags);
        } else {
            this.assessmentAddTags.push(e.value);
            console.log(this.assessmentAddTags);
        }
    }

    onItemRemoved(assessmentType, e, removeFromDataBase: boolean = false) {
        console.log("onItemRemoved", e);

        if (assessmentType === 1) {
            const index = this.assessmentEliTags.indexOf(e.value);
            if (index !== -1) this.assessmentEliTags.splice(index, 1);
            console.log(this.assessmentEliTags);
            this.getCoachCompletedAssessmentsByTypeByTag(1, this.assessmentEliTags);
        } else if (assessmentType === 2) {
            const index = this.assessment360Tags.indexOf(e.value);
            if (index !== -1) this.assessment360Tags.splice(index, 1);
            console.log(this.assessment360Tags);
            this.getCoachCompletedAssessmentsByTypeByTag(2, this.assessment360Tags);
        } else {
            const index = this.assessmentAddTags.indexOf(e.value);
            if (index !== -1) this.assessmentAddTags.splice(index, 1);
            console.log(this.assessmentAddTags);
        }

        let tagText: string;
            if (e.value) {
                tagText = e.value;
            } else {
                tagText = e;
            }
        if(removeFromDataBase) {
            this._CoachService.postRemoveTag(String(this.selectedRow.Id), tagText)
            .subscribe((response: any) => {
                if (this._Globals.validationToken(response.result.Result)) {
                    if (response.result.Result == 1) {
                        this._toastr.success('Tag removed successfully', 'ELI');
                    } else {
                        this._toastr.error('We are sorry, unexpected error removing the tag', 'ELI');
                    }
                }
            },
            (err) => {
                this._toastr.error('We are sorry, unexpected error removing the tag', 'ELI');
            });
        }
    }

    onResize(event: any) {
        //console.log("Width: " , event.currentTarget.innerWidth);
        //console.log("Height: " , event.currentTarget.innerHeight);
        setTimeout(() => {
            if (this.assessmentType === 2.1) {
                if (this.regularGridApi != undefined) {
                    this.sizeToFit(this.regularGridApi);
                }
            } else {
                if (this.gridApi360 != undefined) {
                    this.sizeToFit(this.gridApi360);
                }
            }
        }, 500);
    }

    showCompletedTabs() {
        $('.completedTabs div').removeClass('active in');
        $('.completedTabs li').removeClass('active');
        $('.completedTabs li').eq(0).addClass('active');
        $('#completedTab1').addClass('active');
        $('#completedTab1').addClass('in');
    }


    tabSelected(index:number) {
        console.log(index);
        this.assessmentType = index;
        this.deselectAllCheckBox(this.regularGridApi);
        this.deselectAllCheckBox(this.gridApi360);

        if (index === 2.1) {
            this.sizeToFit(this.regularGridApi);
        } else {
            this.sizeToFit(this.gridApi360);
        }
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 500);
    }

    deselectAllCheckBox(gridApi) {
        gridApi.forEachNode(function (node) {
            node.setSelected(false);
        });
    }

    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit(gridApi) {
        gridApi.sizeColumnsToFit();
        //$('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(grid: number, params) {
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
        if (grid === 1) {
            this.regularGridApi = params.api;
            this._Globals.completedAssessmentGridApi = params.api;
        } else {
            this.gridApi360 = params.api;
        }
        //this.sizeToFit(this.gridApi);
    }

    createHeaders() {
        let columnDefs = new Array();

        //let actionsHeader = {
        //    headerName: 'Actions',
        //    field: '',
        //    width: 85,
        //    minWidth: 85, 
        //    suppressSizeToFit: false, 
        //    suppressSorting: true,
        //    suppressMenu: true,
        //    cellRenderer: function (params) {
        //        let content = '';

        //        content += '<i id="descriptionAction" class="material-icons">description</i>';

        //        content += '<i id="shareAction" class="material-icons">share</i>';

        //        content += '<i data-toggle="dropdown" class="material-icons custom-icons">file_download</i><ul class="dropdown-menu"><li id="clientDownload"><a id="clientDownload"><i id="clientDownload" class="material-icons custom-icons"> file_download </i> Client</a></li><li id="coachDownload"><a id="coachDownload"><i id="coachDownload" class="material-icons custom-icons">file_download</i> Coach</a></li></ul><a title="View Results"></a>';

        //        return '<span style="margin-top: 4px !important; position: absolute;">' + content + '</span>';

        //    }
        //};
        //columnDefs.push(actionsHeader);

        let coachHeader = {
            headerName: 'Client',
            field: 'ClientFullName',
            minWidth: 150,
            width: 150,
             headerCheckboxSelection: true,
             headerCheckboxSelectionFilteredOnly: true,
             checkboxSelection: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(coachHeader);

        //let coachHeader = {
        //    headerName: 'Client',
        //    field: 'ClientFullName',
        //    minWidth: 150,
        //    width: 150,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(coachHeader);

        //let nicheHeader = {
        //    headerName: 'Niche',
        //    field: 'Niche',
        //    minWidth: 150,
        //    width: 150,
        //    suppressSizeToFit: true,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(nicheHeader);

        //let versionHeader = {
        //    headerName: 'Version',
        //    field: '',
        //    minWidth: 100,
        //    width: 100,
        //    suppressSizeToFit: true,
        //    cellRenderer: function (params) {
        //        let version = params.data['AssessmentMajorVersion'] + "." + params.data['AssessmentMinorVersion'];
        //        return version;
        //    }
        //};
        //columnDefs.push(versionHeader);

        let nicheHeader = {
            headerName: 'Assessment',
            field: 'AssessmentName',
            minWidth: 150,
            width: 150,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';

            }
        };
        columnDefs.push(nicheHeader);

        let completedHeader = {
            headerName: 'Completed on',
            field: 'CompletedOnDateTime',
            minWidth: 175,
            width: 175,
            sort: "desc",
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(completedHeader);

        return columnDefs;
    }

    public onRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            console.log('data', data);
            this.descriptionAction(data['Id']);
            //switch (e.event.target.id) {
            //    case "descriptionAction":
            //        {
            //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
            //            this.descriptionAction(data['Id']);
            //            break;
            //        }

            //    case "shareAction":
            //        {
            //            this.shareAction();
            //            break;
            //        }

            //    case "clientDownload":
            //        {
            //            this.downloadAssessment(data['ClientId'], data['Id'], 3);
            //            break;
            //        }

            //    case "coachDownload":
            //        {
            //            this.downloadAssessment(data['ClientId'], data['Id'], 2);
            //            break;
            //        }
            //}
        }
    }

    downloadAssessment(clientId: number, assignmentId: number, userType: number) {
        this._DownloadAssessmentManager.downloadReport(clientId, assignmentId, userType, this);
    }
    

    descriptionAction(assignmentId: number) {
        this.router.navigate(['/app/co_a_report', assignmentId, 'manage_assessments_completed', 1]);
    }

    shareAction() {
        console.log('shareAction');
    }

    onSelectionChanged(event) {
        console.log("onSelectionChanged ", event);
        this.selectedRowsCount = event.api.getSelectedNodes().length;
        let rowCount = event.api.getSelectedNodes().length;
        if (rowCount === 1) {
            this.selectedRow = event.api.getSelectedNodes()[0].data;
        }

        if (this.assessmentType === 2.1) {
            this.rowCountData = this.getSelectedRows(this.regularGridApi);
        } else {
            this.rowCountData = this.getSelectedRows(this.gridApi360);
        }
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount >= 1) {
            this._Globals.completedCanEnableResults = true;
            this._Globals.completedCanArchiveAssessments = true;
            this._Globals.completedCanAddTags = true;
        } else {
            this._Globals.completedCanEnableResults = false;
            this._Globals.completedCanArchiveAssessments = false;
            this._Globals.completedCanAddTags = false;
        }

        if (rowCount === 1) {
            let rows;
            if (this.assessmentType === 2.1) {
                rows = this.getSelectedRows(this.regularGridApi);
            } else {
                rows = this.getSelectedRows(this.gridApi360);
            }
            let is360 = true;
            rows.forEach((assessment) => {
                console.log(assessment);
                if (!assessment.Is360) {
                    is360 = false;
                    return;
                }
            });
            if (is360) {
                this.canAddRaters = true;
            } else {
                this.canAddRaters = false;
            }
        } else {
            this.canAddRaters = false;
        }
    }

    getSelectedRows(gridApi): any {
        console.log("SELECTED", gridApi.getSelectedRows());
        return gridApi.getSelectedRows();
    }


    enableClientSeeResults() {
        if (this._Globals.completedCanEnableResults) {
            var selected;
            if (this.assessmentType === 2.1) {
                selected = this.getSelectedRows(this.regularGridApi);
            } else {
                selected = this.getSelectedRows(this.gridApi360);
            }

            this.enabling = true;
            console.log(selected);
            let assignmentIds = [];

            selected.forEach((item) => {
                console.log(item.Id);
                assignmentIds.push(item.Id)
            })
            this._CoachService.postEnableClientSeeResults(assignmentIds, true).subscribe((data: any) => {
                console.log("PostEnableClientSeeResults_response", data);
                if (this._Globals.validationToken(data.result.Result)) {
                    console.log(data);
                    this._toastr.success("Results enabled successfully.", "ELI");
                    this.enabling = false;
                }
            });
        }
    }

    focusTagsInput(id) {
        $('#' + id).focus();
    }

    /*Get Coach Tags*/
    openTagsModal(type: number) {
        this.currentAssessmentType = type;
        $("#completedTagsModal").modal({ backdrop: "static" });
        $('#completedTagsModal').modal('show');
        this.coachTagsHeaders = this.createCoachTagsHeaders();
        this.getCoachTags();
        this.sizeToFit(this.coachTagsGridApi);
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    openAddTagsAssessmentsModal() {
        if (!this._Globals.completedCanAddTags) {
            return;
        }

        console.log('openAddTagsAssessmentsModal');

        if (this.selectedRowsCount > 1) {
            $("#completedAddTagsModal").modal({ backdrop: "static" });
            $('#completedAddTagsModal').modal('show');
            return;
        }
        
        this._CoachService.getTagsByAssignmentId(this.selectedRow.Id)
            .subscribe((response: any) => {
                if (this._Globals.validationToken(response.result.Result)) {
                    if (response.result.Result == 1) {
                        this.addTags = JSON.parse(response.result.Data).map((t: any) => t.Text);
                        $("#completedAddTagsModal").modal({ backdrop: "static" });
                        $('#completedAddTagsModal').modal('show');
                    } else {
                        this._toastr.error("We are sorry. An error occurred while trying to get assignment tags.","ELI");
                    }
                }
            });
    }

    closeAddTagsModal() {
        $('#completedAddTagsModal').modal('hide');
        this.assessmentAddTags = [];
        this.addTags = [];        
    }

    addAssessmentsTags() {
        console.log('assessmentAddTags', this.assessmentAddTags);
        console.log('addTags', this.addTags);

        let selected;
        if (this.assessmentType === 2.1) {
            selected = this.getSelectedRows(this.regularGridApi);
        } else {
            selected = this.getSelectedRows(this.gridApi360);
        }

        console.log(selected);
        let assignmentIds = [];

        selected.forEach((item) => {            
            assignmentIds.push(item.Id)
        });

        console.log('assignmentIds', assignmentIds);

        this._CoachService.postAddAssessmentsTags(assignmentIds, this.assessmentAddTags).subscribe((data: any) => {
            console.log("postAddAssessmentsTags_RESPONSE", data);
            if (this._Globals.validationToken(data.result.Result)) {
                console.log(data);
                this.closeAddTagsModal();

                switch (data.result.Result) {
                    case 0:
                        this._toastr.error('We are sorry. An error happened when trying to add the tags to the selected assignments', 'ELI');
                        break;

                    case 1:
                        this._toastr.success('Tags were successfully added to the selected assignments');
                        if (this.assessmentType === 2.1) {
                            this.getCoachCompletedAssessmentsByType(1);
                        } else {
                            this.getCoachCompletedAssessmentsByType(2);
                        }
                        break;
                }
            }
        });
    }

    onCoachTagsGridReady(params) {
        this.coachTagsGridApi = params.api;
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    createCoachTagsHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Tag',
            field: 'Text',
            minWidth: 200,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);


        return columnDefs;
    }

    onCoachTagsRowClicked(e) {
        console.log(e);
    }

    onCoachTagsSelectionChanged(event) {
        console.log("onCoachTagsSelectionChanged ", event);

        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        this.selectedCoachTags = this.getSelectedRows(this.coachTagsGridApi);
        console.log("selectedCoachTags", this.selectedCoachTags);
    }


    getCoachTags() {
        this._CoachService.getCoachTags().subscribe((data: any) => {
            console.log('getCoachTags data', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('response_GetCoachTags', _data);
                this.coachTags = _data;
            }
        });
    }

    removeTag(index, text) {
        console.log(index);

        this.selectedCoachTags.splice(index, 1);
        console.log(this.selectedCoachTags);

        this.coachTagsGridApi.forEachNode((node) => {
            console.log(node);
            if (text === node.data.Text) {
                node.setSelected(false);
            }
        });
    }

    addNewCoachTags() {

        this.selectedCoachTags.forEach((item) => {

            if (this.currentAssessmentType === 1) {
                if (!this.tags.find(x => x.value === item.Text)) {
                    let tag = { display: item.Text, value: item.Text };
                    this.tags.push(tag);
                    this.onItemAdded(1, tag);
                }
            } else if (this.currentAssessmentType === 2) {
                if (!this.tags360.find(x => x.value === item.Text)) {
                    let tag = { display: item.Text, value: item.Text };
                    this.tags360.push(tag);
                    this.onItemAdded(2, tag);
                }
            } else {
                if (!this.addTags.find(x => x.value === item.Text)) {
                    let tag = { display: item.Text, value: item.Text };
                    this.addTags.push(tag);
                    this.onItemAdded(3, tag); //add tags modal
                }
            }

        });
        this.closeTagsModal();
    }

    isInArray(value, array) {
        return array.indexOf(value) > -1;
    }

    closeTagsModal() {
        $('#completedTagsModal').modal('hide');
        this.selectedCoachTags = [];
    }

    /*Archive Assessments*/
    openArchiveAssessmentsConfirmationModal() {
        if (this._Globals.completedCanArchiveAssessments) {
            $("#archiveConfirmationModal").modal({ backdrop: "static" });
            $('#archiveConfirmationModal').modal('show');
        }
    }

    closeArchiveAssessmentsConfirmationModal() {
        if (this._Globals.completedCanArchiveAssessments) {
            $('#archiveConfirmationModal').modal('hide');
            this._Globals.completedCanArchiveAssessments = false;
            this._Globals.completedCanEnableResults = false;
        }
    }

    archiveAssessments() {
        if (this._Globals.completedCanArchiveAssessments) {
            var selected;
            if (this.assessmentType === 2.1) {
                selected = this.getSelectedRows(this.regularGridApi);
            } else {
                selected = this.getSelectedRows(this.gridApi360);
            }

            this.archiving = true;
            console.log(selected);
            let assignmentIds = [];

            selected.forEach((item) => {
                console.log(item.Id);
                assignmentIds.push(item.Id)
            });
            console.log(assignmentIds);

            let data = {
                "AssignmentIds": assignmentIds,
                "Archived": 1
            };

            this._CoachService.postArchiveAssessments(this._CryptoJs.encrypt(JSON.stringify(data), 'Os6v70$B&E!H@MlKfTj9nZ34tPw!z%8*')).subscribe((data: any) => {
                if (this._Globals.validationToken(data.result.Result)) {
                    console.log('postArchiveAssessments_response', data.result.Result);

                    switch (data.result.Result) {
                        case -1:
                            this._toastr.error('We are sorry. Some of the selected assessments could not be archived', 'ELI');
                            break;

                        case 0:
                            this._toastr.error('We are sorry. An unexpected error happened when trying to archive the assessment(s)', 'ELI');
                            break;

                        case 1:
                            this._toastr.success('Assessment(s) archived successfully');
                            break;
                    }
                    this.archiving = false;
                    console.log(this.assessmentType);
                    if (this.assessmentType === 2 || this.assessmentType === 2.1) {
                        this.getCoachCompletedAssessmentsByType(1);
                    }else {
                        this.getCoachCompletedAssessmentsByType(2);
                    }
                    this.closeArchiveAssessmentsConfirmationModal();
                }
            });

        }
    }

    public getDisplayTagsCount(): number {
        const tags = $('[ng-reflect-input-id=completedTagsInput] > .ng2-tag-input > .ng2-tags-container > tag');

        return tags.length;
    }

    public getDisplay360TagsCount(): number {
        const tags = $('[ng-reflect-input-id=completedTagsInput360] > .ng2-tag-input > .ng2-tags-container > tag');

        return tags.length;
    }

    public reloadApplyingTagsFilter(): void {
        const tags = $('[ng-reflect-input-id=completedTagsInput] > .ng2-tag-input > .ng2-tags-container > tag')
        for(let count: number = 0; count< tags.length; count++){
            const tagText = tags[count].children[0].children[0].innerText.trim();
            this.tags.push(tagText);
            this.assessmentEliTags.push(tagText);
        }

        if (tags.length > 0) {
            this.getCoachCompletedAssessmentsByTypeByTag(1, this.assessmentEliTags);
        }
    }

    public reloadApplying360TagsFilter(): void {
        const tags360 = $('[ng-reflect-input-id=completedTagsInput360] > .ng2-tag-input > .ng2-tags-container > tag')
        for(let count: number = 0; count< tags360.length; count++){
            const tagText = tags360[count].children[0].children[0].innerText.trim();
            this.tags360.push(tagText);
            this.assessment360Tags.push(tagText);
        }

        if (tags360.length > 0) {
            this.getCoachCompletedAssessmentsByTypeByTag(2, this.assessment360Tags);
        }
    }

    public openCSVDownloadModal(): void {
        if (this._Globals.completedCanAddTags) {
            this.documentNameControl.setValue('');
            this.documentNameControl.markAsPristine();
            $("#CSVDownloadModal").modal({ backdrop: "static" });
            $('#CSVDownloadModal').modal('show');
        }
    }

    public downloadGroupAverageFile(): void {
        this.documentNameControl.setValue(String(this.documentNameControl.value).trim());
        this.documentNameControl.markAsDirty();
        if (this.documentNameControl.invalid) {
            return;
        }
        this.downloading = true;

        const documentName = String(this.documentNameControl.value);

        const assignmentIds = this.rowCountData.map((r: any) => String(r.Id));
        this._CoachService.getGroupAveragesForArlAndPerceptionCharts(assignmentIds)
            .subscribe((response: any) => {
                if (this._Globals.validationToken(response.result.Result)) {
                    const data = String(JSON.parse(response.result.Data));
                    this._DownloadAssessmentManager.base64ToBlob(data, documentName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    this.downloading = false;
                    $('#CSVDownloadModal').modal('hide');
                }
            },
            (err) => {
                this.downloading = false;
                this._toastr.error('We are sorry. An unexpected error happened when trying to export results', 'ELI')
            },
            () => {
                this.downloading = false;
            });
    }

}
